/**
 * /devhub/tool-gateway — Tool gateway (operator). Surface Layer (/01). REQ-001.91 Phase 3.
 * Live operator panel (DevHubToolGatewayPanel) wired to its useDevHub* hook over GET /api/control/registry/:name.
 * Operator-only (routePolicy plane guard + DevHubPanelPage self-guard).
 */
import { createFileRoute } from '@tanstack/react-router';
import { DevHubToolGatewayPanel } from '../features/control-plane/DevHubToolGatewayPanel';
import { DevHubPanelPage } from '../components/devhub/DevHubPanelPage';

export const Route = createFileRoute('/devhub/tool-gateway')({ component: ToolGatewayPage });

function ToolGatewayPage() {
  return (
    <DevHubPanelPage
      title="Tool gateway"
      subtitle="ToolGateway routes — provenance, purpose and approval state."
      status={{ label: 'live', live: true }}
    >
      <DevHubToolGatewayPanel />
    </DevHubPanelPage>
  );
}
